import { Card, CardContent } from "@/components/ui/card";
import { Search, Compass, Wrench } from "lucide-react";

const processSteps = [
  {
    icon: Search,
    title: "ESTUDIO",
    description: "En esta fase inicial, nuestro equipo inicia la observación. Evaluamos tus necesidades específicas, considerando las regulaciones locales y los estándares de seguridad. Realizamos un estudio detallado de las condiciones actuales, identificando áreas de mejora y oportunidades para optimizar la eficiencia."
  },
  {
    icon: Compass,
    title: "DISEÑO",
    description: "Desarrollamos soluciones personalizadas que se adaptan perfectamente a tus requerimientos. Nuestro equipo de ingenieros crea diseños técnicos detallados, seleccionando los materiales y tecnologías más apropiados para garantizar resultados óptimos y duraderos."
  },
  {
    icon: Wrench,
    title: "IMPLEMENTACIÓN",
    description: "Esta etapa sienta las bases para el diseño y la implementación eficaces del proyecto eléctrico. Ejecutamos cada proyecto con precisión, cumpliendo con los más altos estándares de calidad y seguridad, asegurando resultados que superan las expectativas."
  }
];

const Process = () => {
  return (
    <section className="py-24 bg-light-gray relative overflow-hidden">
      <div className="absolute inset-0 opacity-50" style={{ background: 'var(--gradient-mesh)' }} />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-20 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-montserrat font-bold mb-6 text-balance">
            NUESTRO PROCESO
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-inter leading-relaxed">
            Un enfoque sistemático para garantizar el éxito de cada proyecto
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {processSteps.map((step, index) => (
            <Card 
              key={index} 
              className="glass-liquid-medium hover-liquid border-border-glass-medium group cursor-pointer relative overflow-hidden shadow-liquid-lg"
            >
              {/* Shimmer Effect */}
              <div className="absolute inset-0 glass-shimmer opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              
              <CardContent className="p-8 relative z-10">
                <div className="glass-liquid-light w-20 h-20 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 liquid-bounce shadow-liquid-md">
                  <step.icon className="w-10 h-10 text-primary group-hover:scale-110 transition-transform duration-500" />
                </div>
                
                <div className="flex items-center gap-4 mb-4">
                  <span className="text-6xl font-montserrat font-bold text-primary/20">
                    0{index + 1}
                  </span>
                  <h3 className="text-xl font-montserrat font-bold group-hover:text-primary transition-colors">
                    {step.title}
                  </h3>
                </div>
                
                <p className="text-muted-foreground font-inter leading-relaxed text-justify hyphens-auto">
                  {step.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
